import { create } from 'zustand'
import { ThemeColors } from '../types'

export const generateTheme = (type: 'light' | 'dark'): Omit<ThemeColors, 'name'> => {
    if (type === 'light') {
        return {
            background: '#FFFFFF',
            text: '#272727',
            black: '#000000',
            white: '#FFFFFF',
            gray: '#666666',
            light: '#F8F8FF',
            dark: '#222222',
            primary: '#38B14A',
            secondary: '#FFDA18',
            tertiary: '#5D412C',
            accent: '#26DCA9',
            success: '#33FF86',
            warning: '#FFB538',
            error: '#FA6060',
            info: '#1884FF',
            disabled: '#CCCCCC',
            textSecondary: '#666666',
            textTertiary: '#111111',
            surface: '#F8F8FF',
            border: '#E5E7EB',
            profile: {
                description: {
                    background: '#272727',
                    text: '#FFFFFF'
                }
            },
            sideMenu: {
                background: '#EEEEEE',
                item: '#222222',
                text: '#000000'
            }
        }
    } else {
        return {
            background: '#1A1A1A',
            text: '#FFFFFF',
            black: '#000000',
            white: '#FFFFFF',
            gray: '#999999',
            light: '#333333',
            dark: '#111111',
            primary: '#38B14A',
            secondary: '#FFDA18',
            tertiary: '#5D412C',
            accent: '#26DCA9',
            success: '#33FF86',
            warning: '#FFB538',
            error: '#FA6060',
            info: '#1884FF',
            disabled: '#666666',
            textSecondary: '#999999',
            textTertiary: '#FFFFFF',
            surface: '#2A2A2A',
            border: '#404040',
            profile: {
                description: {
                    background: '#272727',
                    text: '#FFFFFF'
                }
            },
            sideMenu: {
                background: '#333333',
                item: '#111111',
                text: '#FFFFFF'
            }
        }
    }
}

interface ThemeStore {
    theme: 'light' | 'dark'
    colors: Omit<ThemeColors, 'name'>
    toggleTheme: () => void
    setTheme: (theme: 'light' | 'dark') => void
}

export const useThemeStore = create<ThemeStore>((set) => ({
    theme: 'dark',
    colors: generateTheme('dark'),
    toggleTheme: () => set((state) => {
        const newTheme = state.theme === 'light' ? 'dark' : 'light'
        return {
            theme: newTheme,
            colors: generateTheme(newTheme)
        }
    }),
    setTheme: (theme) => set({
        theme,
        colors: generateTheme(theme)
    })
}))
